import { action, computed, observable } from 'mobx';
import { put } from '../../../services/request';
const config =
  require(`../../../@${process.env.REACT_APP_TENANT}/config.js`).default;

export default class RoundStore {
  constructor({ root }) {
    this.root = root;
  }

  @observable definition = {};

  @computed get mode() {
    return this.definition.status &&
      (this.definition.status === 'notStarted' ||
        this.definition.status === 'closed')
      ? 'new'
      : 'edit';
  }

  @computed get canChangeType() {
    var result =
      !!this.definition.number &&
      (this.definition.number <= 1 || config.canChangeRoundType) &&
      !this.isOpen;

    return result;
  }

  @computed get isStarted() {
    return !!this.definition.status && this.definition.status === 'started';
  }

  @computed get isOpen() {
    return !!this.definition.status && this.definition.status === 'opened';
  }

  @computed get isClosed() {
    return !!this.definition.status && this.definition.status === 'closed';
  }

  @computed get type() {
    return !!this.definition.type ? this.definition.type : undefined;
  }

  @computed get isOpenBidding() {
    return this.type === 'open_bidding';
  }

  @computed get isSimpleOffer() {
    return this.type === 'simple_offer';
  }

  @action start({ saleId, ...round }) {
    put(
      `/api/v1/sales/${this.root.saleId}/startround`,
      round,
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action edit({ saleId, ...round }) {
    const data = {
      ...round,
      biddingSteps: round.biddingSteps ? round.biddingSteps.toString() : null,
    };
    put(
      `/api/v1/sales/${this.root.saleId}/editround`,
      data,
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action open() {
    put(
      `/api/v1/sales/${this.root.saleId}/openround`,
      {},
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action close() {
    put(
      `/api/v1/sales/${this.root.saleId}/closeround`,
      {},
      this.root.user.accessToken
    ).then(this.root.success, this.root.failed);
  }

  @action reset() {
    this.definition = {};
    this.reqError = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/RoundStore.js